import React from 'react';

const TOEFLUpsellContent: React.FC = (props) => {
  return (
    <ul className="u-padding-L-m">
      <li>Graded writing assignments</li>
      <li>Practice tests</li>
      <li>Expert video lessons</li>
      <li>Custom study schedules</li>
      <li>420+ practice questions</li>
      <li>Accurate score prediction</li>
    </ul>
  );
};

export default TOEFLUpsellContent;
